// import React from "react";
// import "./Global_Family_Sleepers.css";
// import Common_Title_2 from "../../common_components/common_title_2/Common_Title_2";

// const GlobalFamilySleepers = () => {
//   return (
//     <section className="global-family">
//       <div className="global-container container">
//         <div className="global-content">

//               <Common_Title_2 title={"A Global Family of Sleepers"}/>

//           <p className="global-text">
//             From our local roots to our expanding Global Presence, Majesty has
//             earned the trust of over 1,000,000 happy customers.
//           </p>

//           <p className="global-text">
//             We are proud to be a trusted partner in bedrooms across the world,
//             helping a million people reclaim their rest and wake up to a “New
//             Chapter in Sleep.”
//           </p>
//         </div>

//         <div className="global-image-wrapper">
//           <div className="image-border"></div>
//           <img
//             src="/assets/images/about-us/man_img.png"
//             alt="Sleeping man"
//             className="global-image"
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default GlobalFamilySleepers;

import React from "react";
import "./Global_Family_Sleepers.css";
import Common_Title_2 from "../../common_components/common_title_2/Common_Title_2";

const GlobalFamilySleepers = () => {
  return (
    <section className="global-family">
      <div className="global-container container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="global-content">
              {/* <h2 className="global-title">A Global Family of Sleepers</h2> */}
              <Common_Title_2 title={"A Global Family of Sleepers"} />

              <p className="global-text">
                From our local roots to our expanding Global Presence, Majesty
                has earned the trust of over 1,000,000 happy customers.
              </p>

              <p className="global-text">
                We are proud to be a trusted partner in bedrooms across the
                world, helping a million people reclaim their rest and wake up
                to a “New Chapter in Sleep.”
              </p>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="global-image-wrapper">
              <div className="image-border"></div>
              <img
                src="/assets/images/about-us/man_img.png"
                alt="Sleeping man"
                className="global-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalFamilySleepers;
